"use strict";
exports.__esModule = true;
exports.FORM_PROGRESS = void 0;
var FORM_PROGRESS = {
    STEP_STATUS: {
        UNVISITED: 'UNVISITED',
        VISITED: 'VISITED',
        COMPLETED: 'COMPLETED'
    },
    STEP_NAMES: {
        CLIENT_INVITATION: 'clientInvitation',
        CLIENT_DETAILS: 'clientDetails',
        CLIENT_IDENTIFICATION: 'clientIdentification',
        FILL_METHOD_SELECTION: 'financialsFillMethodSelection',
        CREDIT_REPORT: 'creditReport',
        INCOME_AND_ASSETS: 'incomeAndAssets',
        EXPENSES_AND_LIABILITIES: 'expensesAndLiabilities',
        APPLICANT_APPROVAL: 'applicantApproval',
        GOALS: 'goals',
        OPTIONS: 'options',
        LOAN_OPTIONS: 'loanOptions',
        PRE_APPROVAL: 'preApproval'
    }
};
exports.FORM_PROGRESS = FORM_PROGRESS;
